import { Component, Input, OnInit, ElementRef, ViewChild } from "@angular/core";
import { GlobalsService } from "../../api/globals.service";
import { NavController, AlertController } from "@ionic/angular";
import { Router } from "@angular/router";
import { ForumsService } from "../../services/forums.service";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-comments-forums",
  templateUrl: "./comments-forums.component.html",
  styleUrls: ["./comments-forums.component.scss"],
})
export class CommentsForumsComponent implements OnInit {
  @Input() idForum: number;
  //{
  //   this.forum = id;
  //   // this.authService.userData$.subscribe((res: any) => {
  //   //   if(!this.displayUserData){
  //   //     this.displayUserData =  res;
  //   //     this.loadVariables();
  //   //     this.getForumById();
  //   //     this.getCommentsByForum();
  //   //   }
  //   // });
  //   // this.getForumById();
  //   // this.getCommentsByForum();
  // };

  ismobile: boolean;
  displayUserData: any;
  envioComentario: string = "";
  btnAnterior: string = "";
  commentAnterior: string = "";
  textButton = "Editar Comentario";
  textButtonB = false;

  comments: any = [];
  answers: any = [];
  dataForum: any;

  constructor(
    public globalsService: GlobalsService,
    public navCtrl: NavController,
    private router: Router,
    private forumServices: ForumsService,
    private authService: AuthService,
    private alertCtrl: AlertController
  ) {
    this.ismobile = globalsService.isMobile;
  }

  ngOnInit() {
    this.authService.userData$.subscribe((res: any) => {
      if (!this.displayUserData) {
        this.displayUserData = res;
        this.getForumById();
        this.getCommentsByForum();
      }
    });
  }

  getCommentsByForum() {
    this.forumServices
      .getCommentsByForum(
        this.displayUserData.id,
        this.displayUserData.auth_key,
        this.idForum
      )
      .subscribe((res) => {
        this.comments = res;
      });
  }

  getForumById() {
    this.forumServices
      .getForumById(
        this.displayUserData.id,
        this.displayUserData.auth_key,
        this.idForum
      )
      .subscribe((res) => {
        this.dataForum = res;
        console.log(this.dataForum);
      });
  }

  async editComment(posEdit, btnId, id_comentario, username) {
    this.textButton = "";

    if (
      (<HTMLInputElement>document.getElementById(btnId)).innerHTML ==
      "Enviar comentario"
    ) {
      const envioEdicion = (<HTMLInputElement>(
        document.getElementById(posEdit)
      )).value.replace("@" + username + " ", "");
      // envioEdicion = envioEdicion.replace('@'+username+' ','');

      const alert = await this.alertCtrl.create({
        header: "Editar Comentario",
        message: "¿Deseas editar comentario?",
        buttons: [
          {
            text: "Cancelar",
            role: "cancel",
            handler: () => {
              (<HTMLInputElement>(
                document.getElementById(btnId)
              )).classList.remove("editComment");
              (<HTMLInputElement>document.getElementById(btnId)).classList.add(
                "notEditComment"
              );
              (<HTMLInputElement>(
                document.getElementsByName(posEdit)[0]
              )).readOnly = true;
              (<HTMLInputElement>document.getElementById(btnId)).innerHTML =
                "Editar comentario";
              this.btnAnterior = "";
              this.commentAnterior = "";
            },
          },
          {
            text: "Aceptar",
            handler: () => {
              this.editComentario(id_comentario, envioEdicion);
            },
          },
        ],
      });

      await alert.present();
    } else {
      if ((<HTMLInputElement>document.getElementsByName(posEdit)[0]).readOnly) {
        if (this.btnAnterior != "" && this.btnAnterior != null) {
          (<HTMLInputElement>(
            document.getElementById(this.btnAnterior)
          ))?.classList.remove("editComment");
          (<HTMLInputElement>(
            document.getElementById(this.btnAnterior)
          ))?.classList.add("notEditComment");
          (<HTMLInputElement>(
            document.getElementById(this.btnAnterior)
          )).innerHTML = "Editar comentario";
          (<HTMLInputElement>(
            document.getElementsByName(this.commentAnterior)[0]
          )).readOnly = true;
          this.btnAnterior = "";
          this.commentAnterior = "";
        }
        (<HTMLInputElement>document.getElementsByName(posEdit)[0]).readOnly =
          false;
        document.getElementsByName(posEdit)[0].focus();
        (<HTMLInputElement>document.getElementById(btnId)).classList.remove(
          "notEditComment"
        );
        (<HTMLInputElement>document.getElementById(btnId)).classList.add(
          "editComment"
        );
        (<HTMLInputElement>document.getElementById(btnId)).innerHTML =
          "Enviar comentario";
        this.btnAnterior = btnId;
        this.commentAnterior = posEdit;
      } else {
        (<HTMLInputElement>document.getElementById(btnId)).classList.remove(
          "editComment"
        );
        (<HTMLInputElement>document.getElementById(btnId)).classList.add(
          "notEditComment"
        );
        (<HTMLInputElement>document.getElementsByName(posEdit)[0]).readOnly =
          true;
        (<HTMLInputElement>document.getElementById(btnId)).innerHTML =
          "Editar comentario";
        this.btnAnterior = "";
        this.commentAnterior = "";
      }
    }
  }

  responder(idResp, idComMayor, username) {
    const envioRespuesta = (<HTMLInputElement>document.getElementById(idResp))
      .value;
    if (envioRespuesta != "" && envioRespuesta != null) {
      this.forumServices
        .crearComment(
          this.displayUserData.id,
          this.displayUserData.auth_key,
          this.idForum,
          envioRespuesta,
          idComMayor,
          username
        )
        .subscribe((res: any) => {
          if (!res.auth_key) {
          } else if (res.error) {
            alert("ocurrió un error");
          } else if (res.validate) {
            this.getCommentsByForum();
            this.presentAlert(1);
          }
        });
    } else {
      this.presentAlert(2);
    }
  }

  comentar() {
    if (this.envioComentario != "" && this.envioComentario != null) {
      this.forumServices
        .crearComment(
          this.displayUserData.id,
          this.displayUserData.auth_key,
          this.idForum,
          this.envioComentario
        )
        .subscribe((res: any) => {
          if (!res.auth_key) {
          } else if (res.error) {
            alert("ocurrió un error");
          } else if (res.validate) {
            this.getCommentsByForum();
            this.envioComentario = "";
          }
        });
    } else {
      this.presentAlert(2);
    }
  }

  editComentario(id_comentario, descripcion) {
    this.forumServices
      .editComment(
        this.displayUserData.id,
        this.displayUserData.auth_key,
        id_comentario,
        descripcion,
        this.idForum
      )
      .subscribe((res: any) => {
        if (!res.auth_key) {
        } else if (res.error) {
          alert("ocurrió un error");
        } else if (res.validate) {
          this.getCommentsByForum();
          this.presentAlert(3);
        }
      });
  }

  sendLikeForum() {
    this.forumServices
      .sendLikeAndDislike(
        this.displayUserData.id,
        this.displayUserData.auth_key,
        this.idForum,
        null,
        "10",
        "ComentarioMeGusta"
      )
      .subscribe((res: any) => {
        if (res.validate) {
          this.getForumById();
        } else console.log("error");
      });
  }

  sendDislikeForum() {
    this.forumServices
      .sendLikeAndDislike(
        this.displayUserData.id,
        this.displayUserData.auth_key,
        this.idForum,
        null,
        "11",
        "ComentarioNoMeGusta"
      )
      .subscribe((res: any) => {
        if (res.validate) {
          this.getForumById();
        } else console.log("error");
      });
  }

  sendLike(id_comentario) {
    this.forumServices
      .sendLikeAndDislike(
        this.displayUserData.id,
        this.displayUserData.auth_key,
        null,
        id_comentario,
        "8",
        "ComentarioMeGusta"
      )
      .subscribe((res: any) => {
        if (res.validate) {
          this.getCommentsByForum();
        } else console.log("error");
      });
  }

  sendDislike(id_comentario) {
    this.forumServices
      .sendLikeAndDislike(
        this.displayUserData.id,
        this.displayUserData.auth_key,
        null,
        id_comentario,
        "9",
        "ComentarioNoMeGusta"
      )
      .subscribe((res: any) => {
        if (res.validate) {
          this.getCommentsByForum();
        } else console.log("error");
      });
  }

  async presentAlert(opc: number) {
    if (opc == 1) {
      const alert = await this.alertCtrl.create({
        header: "Hecho",
        message: "Tu comentario se envio con exito",
        buttons: ["Aceptar"],
      });
      this.envioComentario = "";
      await alert.present();
      const { role } = await alert.onDidDismiss();
    } else if (opc == 2) {
      const alert = await this.alertCtrl.create({
        header: "Alerta",
        message: "Debes escribir un comentario",
        buttons: ["Aceptar"],
      });
      this.envioComentario = "";
      await alert.present();
      const { role } = await alert.onDidDismiss();
    } else if (opc == 2) {
      const alert = await this.alertCtrl.create({
        header: "Alerta",
        message: "Tu comentario se actualizó",
        buttons: ["Aceptar"],
      });
      this.envioComentario = "";
      await alert.present();
      const { role } = await alert.onDidDismiss();
    }
  }
}
